const internalWarehouses = [
  { _id: '1', code: '_', label: 'Catalogue' },
  { _id: '2', code: 'L', label: 'Off season' },
  { _id: '3', code: 'PIA', label: 'In season' },
];

export { internalWarehouses };
